module.exports = __webpack_public_path__ + "static/media/meal.ea3b0b51.svg";